import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {OptionsMapper} from "@magieno/angular-advanced-forms";
import { AlertMessageStore } from '../../../../core/stores/alert-message.store';
import { Quebec2023TaxFormFactory } from './quebec-2023-tax-form.factory';
import { ClientQuestionnaireBase } from '../../base-client-questionnaire/form/base-form/client-questionnaire.base';

import { ClientQuestionnaireStore } from '../../../stores/client-questionnaire.store';

import {
  PrescriptionDrugInsuranceEnum,
} from '../../../../../../../../../common/src/enums/prescription-drug-insurance.enum';
import {
  MainSpouseQuebec2023TaxQuestionnaireOptions,
} from '../../../../../../../../../common/src/options/client-questionnaire/quebec-2023-tax-questionnaire/main-spouse-quebec-2023-tax-questionnaire.options';
import { CivilStatusEnum } from '../../../../../../../../../common/src/enums/civil-status.enum';
import { ErrorsUtils } from '../../../../core/utils/errors.utils';
import { LoggingService } from '../../../../core/services/logging.service';

@Component({
  selector: 'app-quebec-2023-tax-form',
  templateUrl: './quebec-2023-tax-form.component.html',
  styleUrls: ['./quebec-2023-tax-form.component.scss'],
  standalone: false,
})
export class Quebec2023TaxFormComponent extends ClientQuestionnaireBase<MainSpouseQuebec2023TaxQuestionnaireOptions> implements OnInit, OnDestroy {
  prescriptionDrugInsuranceEnum = PrescriptionDrugInsuranceEnum;

  isMainSpouseTab: boolean = true;

  civilStatusEnum = CivilStatusEnum;

  constructor(public readonly formFactory: Quebec2023TaxFormFactory,
              clientQuestionnaireStore: ClientQuestionnaireStore,
              translateService: TranslateService,
              activatedRoute: ActivatedRoute,
              modalService: NgbModal,
              router: Router,
              optionsMapper: OptionsMapper,
              // calculationsUtils: CalculationsUtils,
              alertMessageStore: AlertMessageStore,
              errorsUtils: ErrorsUtils,
              loggingService: LoggingService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
    super(formFactory, clientQuestionnaireStore, translateService, activatedRoute, modalService, router, optionsMapper, alertMessageStore, errorsUtils, loggingService);
    this.optionsType = MainSpouseQuebec2023TaxQuestionnaireOptions;
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}

